// Farbzuordnung der Verbund-Ansicht: jede Firma bekommt EINE Farbe, die in
// Ring, gestapelter Liste und Aufteilungs-Popover dieselbe bleibt.
//
// React-frei, damit die Ring-Mathematik (splitRing) und deren Tests die Palette
// ohne DOM ziehen können.

/**
 * Segmentfarben der Verbund-Ansicht.
 *
 * Bewusst OHNE Rot: Rot ist in diesem Produkt für echte Fehler reserviert
 * (Validierung, Deckungslücken-Ampel) — eine rote Firma im Ring läse sich als
 * Warnung, obwohl sie nur eine Firma ist.
 *
 * Die ersten vier Farben trennen sich in Farbton UND Helligkeit (dunkle
 * Aubergine → helles Amber → dunkles Blau → mittleres Grün). Der Verbund hat
 * meist zwei bis vier Firmen; diese vier bleiben deshalb auch bei
 * Farbfehlsichtigkeit und in Graustufen (Ausdruck!) unterscheidbar. Erst danach
 * folgen Töne, die sich nur noch im Farbton trennen.
 */
export const KZ_PALETTE = [
  "#7d2169",
  "#f0a020",
  "#0f4c81",
  "#15803d",
  "#0d9488",
  "#5b21b6",
  "#a16207",
  "#0e7490",
];

/** Farbe des zusammengefassten „Sonstige"-Segments — neutral, nie aus der Palette. */
export const KZ_REST = "#a294a0";

/**
 * Ordnet jeder Firma des Verbunds ihre feste Farbe zu.
 *
 * Die Zuordnung erfolgt aus der nach `contactId` AUFSTEIGEND sortierten Liste —
 * NICHT aus der Betragsreihenfolge und nicht aus der Anzeigereihenfolge. Nur so
 * behält eine Firma dieselbe Farbe über alle Zeilen und alle Jahre: sortierte man
 * nach Betrag, wechselte die Farbe, sobald eine Firma in einem Jahr mehr umsetzt
 * als eine andere — und eine Firma, deren Wert in einem Jahr fehlt, verschöbe die
 * Farben aller nachfolgenden Firmen.
 */
export function buildColorMap(companyIds: number[]): Map<number, string> {
  const map = new Map<number, string>();
  const eindeutig = Array.from(new Set(companyIds)).sort((a, b) => a - b);
  eindeutig.forEach((id, i) => map.set(id, KZ_PALETTE[i % KZ_PALETTE.length]));
  return map;
}
